<template>
  <div class="form-page">
    <loading v-if="vLoading" />
    <v-row class="justify-content-center">
      <v-col md="8" sm="12">
        <v-card class="my-4 pa-2 top-card">
          <v-container>
            <h3 class="text-center mb-4">فرم مصاحبه - پولاد پیچکار</h3>
            <v-divider></v-divider>
            <h6 style="line-height: 30px">
              کارجوی گرامی، سلام. شما پیش از این متقاضی استخدام در واحد بازرگانی
              شرکت پولاد پیچکار بوده اید. خواهشمند است به منظور شناخت هر چه بهتر
              متقابل، فرم زیر را با دقت پر کنید. پاسخ کامل و دقیق به سوالات زیر،
              در تعیین شغل مناسب و دعوت شما برای مصاحبه تاثیر مستقیم خواهد داشت.
            </h6>
            <br />
            <h6 class="mb-2">
              به منظور کسب اطلاعات بیشتر در خصوص این شرکت میتوانید به وبسایت ما
              مراجعه فرمایید.
            </h6>
            <a href="https://ppkco.com" target="_blank">https://ppkco.com</a>
            <h6 class="mt-6">با تشکر واحد منابع انسانی شرکت پولاد پیچکار</h6>
          </v-container>
        </v-card>
        <v-card class="mb-6 pa-4 main-card">
          <v-container>
            <h4 class="text-center text-primary mb-10">اطلاعات فردی</h4>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.name"
                  label="* نام"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.lastName"
                  label="* نام خانوادگی"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6" class="ps-5 pt-0">
                * جنسیت:
                <v-radio-group row v-model="form.gender" class="mt-2">
                  <v-radio
                    label="مرد"
                    color="primary"
                    value="male"
                    class="ms-0"
                  ></v-radio>
                  <v-radio label="زن" color="primary" value="female"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6" class="ps-5 pt-0">
                * وضعیت تاهل:
                <v-radio-group row v-model="form.marriage" class="mt-2">
                  <v-radio
                    label="مجرد"
                    color="primary"
                    value="single"
                    class="ms-0"
                  ></v-radio>
                  <v-radio
                    label="متاهل"
                    color="primary"
                    value="married"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  label="* کد ملی"
                  outlined
                  dense
                  v-model="form.natCode"
                  type="number"
                  :rules="[rules.isValidNatCode]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.birthCity"
                  label="* محل تولد"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <span class="calendar-icon" id="birthday">
                  <v-text-field
                    outlined
                    dense
                    v-model="form.birthCity"
                    label="تاریخ تولد"
                    append-icon="$Calendar"
                  ></v-text-field>
                </span>
                <date-picker
                  ref="datePicker"
                  v-model="form.birthDate"
                  element="birthday"
                />
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.age"
                  type="number"
                  label="* سن"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  v-model="form.children"
                  label="* تعداد فرزندان"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  v-model="form.custody"
                  label="* تعداد افراد تحت تکفل"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  v-model="form.mobile"
                  label="* شماره تلفن همراه"
                  placeholder="*********09"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <v-text-field
                  outlined
                  dense
                  v-model="form.phone"
                  label="* شماره تلفن ثابت"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  rows="4"
                  outlined
                  dense
                  v-model="form.address"
                  label="* آدرس محل سکونت"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="ps-4 pt-0">
                * نوع محل سکونت:
                <v-radio-group row v-model="form.homeStatus">
                  <v-radio
                    class="ms-0"
                    label="مالک"
                    color="primary"
                    value="مالک"
                  ></v-radio>

                  <v-radio
                    label="استیجاری"
                    color="primary"
                    value="استیجاری"
                  ></v-radio>
                  <v-radio
                    label="زندگی با خانواده"
                    color="primary"
                    value="زندگی با خانواده"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  label="* ایمیل"
                  v-model="form.email"
                  :rules="[rules.isValidEmail]"
                  type="email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card class="mb-6 pa-4 main-card">
          <v-container>
            <h4 class="text-center text-primary mb-10">سوابق تحصیلی</h4>
            <v-row>
              <v-col class="ps-4">
                * آخرین مقطع تحصیلی:
                <v-radio-group row v-model="form.latestDegree">
                  <v-radio
                    label="دیپلم"
                    color="primary"
                    value="دیپلم"
                    class="ms-0"
                  ></v-radio>
                  <v-radio
                    label="کاردانی"
                    color="primary"
                    value="کاردانی"
                  ></v-radio>
                  <v-radio
                    label="کارشناسی"
                    color="primary"
                    value="کارشناسی"
                  ></v-radio>
                  <v-radio
                    label="کارشناسی ارشد"
                    color="primary"
                    value="کارشناسی ارشد"
                  ></v-radio>
                  <v-radio
                    label="دکتری"
                    color="primary"
                    value="دکتری"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                * اطلاعات تحصیلی:
                <v-btn
                  style="float: left"
                  class="mb-3"
                  color="primary"
                  outlined
                  @click="addUniInfo()"
                >
                  <v-icon>mdi-plus</v-icon> افزودن
                </v-btn>
                <v-expansion-panels
                  v-model="openEducation"
                  multiple
                  class="my-4 d-lg-none d-md-none d-sm-block d-block"
                >
                  <v-expansion-panel
                    v-for="(item, index) in form.education"
                    :key="index"
                  >
                    <v-expansion-panel-header>
                      <v-row>
                        <v-col>اطلاعات تحصیلی {{ index + 1 }}</v-col>
                        <v-col class="text-left">
                          <v-btn
                            color="red"
                            outlined
                            style="float: left"
                            @click="deleteUniInfo(index)"
                            >حذف</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12" md="6" lg="6" xl="6">
                          <v-text-field
                            outlined
                            dense
                            v-model="item.grade"
                            label="مقطع*"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6">
                          <v-text-field
                            outlined
                            dense
                            v-model="item.major"
                            label="رشته*"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6">
                          <v-text-field
                            outlined
                            dense
                            type="number"
                            v-model="item.start"
                            label="سال شروع*"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6">
                          <v-text-field
                            outlined
                            dense
                            type="number"
                            v-model="item.end"
                            label="سال پایان*"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6">
                          <v-text-field
                            outlined
                            dense
                            v-model="item.university"
                            label="دانشگاه*"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <b-table
                  responsive
                  show-empty
                  class="d-lg-block d-md-block d-sm-none d-none"
                  head-variant="light"
                  :fields="educationFields"
                  :items="form.education"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div
                      style="text-align: center; vertical-align: middle"
                      class="pt-3"
                    >
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(grade)="data">
                    <v-text-field
                      v-model="data.item.grade"
                      outlined
                      dense
                      placeholder="مقطع"
                      hide-details
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(start)="data">
                    <v-text-field
                      type="number"
                      v-model="data.item.start"
                      outlined
                      dense
                      placeholder="سال شروع"
                      hide-details
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(end)="data">
                    <v-text-field
                      type="number"
                      v-model="data.item.end"
                      outlined
                      dense
                      placeholder="سال پایان"
                      hide-details
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(university)="data">
                    <v-text-field
                      v-model="data.item.university"
                      outlined
                      dense
                      placeholder="دانشگاه"
                      hide-details
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(major)="data">
                    <v-text-field
                      v-model="data.item.major"
                      outlined
                      dense
                      placeholder="رشته"
                      hide-details
                    ></v-text-field>
                  </template>

                  <template v-slot:cell(delete)="data">
                    <div style="text-align: center; vertical-align: middle">
                      <v-btn
                        color="red"
                        outlined
                        class="font-weight-bold"
                        height="40"
                        @click="deleteUniInfo(data.index)"
                        >حذف</v-btn
                      >
                    </div>
                  </template>
                </b-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card class="mb-6 pa-4 main-card">
          <v-container>
            <h4 class="text-center text-primary mb-10">سوابق کاری</h4>
            <v-row>
              <v-col>
                <v-text-field
                  outlined
                  dense
                  label="میزان سابقه کار (سال)"
                  type="number"
                  v-model="form.experience"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                * اطلاعات سوابق کاری:
                <v-btn
                  style="float: left"
                  class="mb-3"
                  color="primary"
                  outlined
                  @click="addJob()"
                >
                  <v-icon>mdi-plus</v-icon>افزودن
                </v-btn>
                <v-expansion-panels
                  v-model="openJob"
                  multiple
                  class="my-4 d-lg-none d-md-none d-sm-block d-block"
                >
                  <v-expansion-panel
                    v-for="(item, index) in form.jobs"
                    :key="index"
                  >
                    <v-expansion-panel-header>
                      <v-row>
                        <v-col>سابقه کاری {{ index + 1 }}</v-col>
                        <v-col class="text-left">
                          <v-btn
                            color="red"
                            outlined
                            style="float: left"
                            @click="deleteJob(index)"
                            >حذف</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12" md="6" lg="6" xl="6">
                          <v-text-field
                            outlined
                            dense
                            v-model="item.company"
                            label="نام شرکت*"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6">
                          <v-text-field
                            outlined
                            dense
                            v-model="item.position"
                            label="سمت*"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6">
                          <v-text-field
                            outlined
                            dense
                            type="number"
                            v-model="item.start"
                            label="سال شروع*"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6">
                          <v-text-field
                            outlined
                            dense
                            type="number"
                            v-model="item.end"
                            label="سال پایان*"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6">
                          <vuetify-money
                            outlined
                            dense
                            v-model="item.salary"
                            :valueWhenIsEmpty="whenIsEmpty"
                            :options="vMoneyOptions"
                            label="حقوق دریافتی(﷼)*"
                            type="number"
                          />
                        </v-col>
                        <v-col cols="12" md="6" lg="6" xl="6">
                          <v-text-field
                            outlined
                            dense
                            v-model="item.reason"
                            label="دلیل ترک کار*"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <b-table
                  responsive
                  show-empty
                  head-variant="light"
                  class="d-lg-block d-md-block d-sm-none d-none"
                  :fields="jobFields"
                  :items="form.jobs"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div
                      style="text-align: center; vertical-align: middle"
                      class="pt-3"
                    >
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(company)="data">
                    <v-text-field
                      v-model="data.item.company"
                      outlined
                      dense
                      hide-details
                      placeholder="نام شرکت"
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(position)="data">
                    <v-text-field
                      v-model="data.item.position"
                      outlined
                      dense
                      hide-details
                      placeholder="سمت"
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(start)="data">
                    <v-text-field
                      type="number"
                      v-model="data.item.start"
                      outlined
                      dense
                      hide-details
                      placeholder="سال شروع"
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(end)="data">
                    <v-text-field
                      type="number"
                      v-model="data.item.end"
                      outlined
                      dense
                      hide-details
                      placeholder="سال پایان"
                    ></v-text-field>
                  </template>
                  <template v-slot:cell(salary)="data">
                    <vuetify-money
                      outlined
                      dense
                      v-model="data.item.salary"
                      :valueWhenIsEmpty="whenIsEmpty"
                      :options="vMoneyOptions"
                      type="number"
                      hide-details
                      placeholder="حقوق دریافتی"
                    />
                  </template>
                  <template v-slot:cell(reason)="data">
                    <v-text-field
                      v-model="data.item.reason"
                      outlined
                      dense
                      hide-details
                      placeholder="دلیل ترک کار"
                    ></v-text-field>
                  </template>

                  <template v-slot:cell(delete)="data">
                    <div style="text-align: center; vertical-align: middle">
                      <v-btn
                        color="red"
                        class="font-weight-bold"
                        outlined
                        @click="deleteJob(data.index)"
                        >حذف</v-btn
                      >
                    </div>
                  </template>
                </b-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card class="mb-6 pa-4 main-card">
          <v-container>
            <v-row>
              <v-col cols="12" md="6" lg="6" xl="6">
                * زمینه همکاری:
                <v-radio-group v-model="form.field">
                  <v-radio
                    v-for="option in jobOpt"
                    :key="option"
                    :label="option"
                    :value="option"
                  >
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="6">
                <vuetify-money
                  label="* حقوق درخواستی (﷼)"
                  outlined
                  dense
                  v-model="form.salary"
                  :valueWhenIsEmpty="whenIsEmpty"
                  :options="vMoneyOptions"
                  type="number"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn :loading="isBusy" color="primary" @click="sendForm()"
                  >ارسال فرم</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import prices from "./../../mixins/prices";
import Axios from "axios";

function checkCodeMeli(code) {
  var L = code.length;

  if (L < 8 || parseInt(code, 10) == 0) return false;
  code = ("0000" + code).substr(L + 4 - 10);
  if (parseInt(code.substr(3, 6), 10) == 0) return false;
  var c = parseInt(code.substr(9, 1), 10);
  var s = 0;
  for (var i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i);
  s = s % 11;
  return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
  return true;
}
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  mixins: [prices],
  data() {
    return {
      form: {
        education: [
          { start: "", end: "", university: "", major: "", grade: "" },
        ],
        jobs: [
          {
            start: "",
            end: "",
            position: "",
            company: "",
            reason: "",
            salary: "",
          },
        ],
        children: 0,
        custody: 0,
        experience: 0,
        salary: "",
        experience: "",
      },
      isBusy: false,
      educationFields: [
        { key: "index", label: "#" },
        { key: "grade", label: "مقطع" },
        { key: "start", label: "سال شروع" },
        { key: "end", label: "سال پایان" },
        { key: "university", label: "دانشگاه" },
        { key: "major", label: "رشته" },
        { key: "delete", label: "عملیات" },
      ],
      jobFields: [
        { key: "index", label: "#" },
        { key: "company", label: "نام شرکت" },
        { key: "position", label: "سمت" },
        { key: "start", label: "سال شروع" },
        { key: "end", label: "سال پایان" },
        { key: "salary", label: "حقوق دریافتی (﷼)" },
        { key: "reason", label: " دلیل ترک کار" },
        { key: "delete", label: "عملیات" },
      ],
      jobOpt: ["کارشناس بازرگانی", "منشی", "امور مالی"],
      openJob: [0],
      openEducation: [0],
    };
  },
  methods: {
    isID(id) {
      // NOTE (m-isID) to check the validity of the national code
      return id ? (checkCodeMeli(id) ? true : false) : true;
    },
    validateEmail(email) {
      //NOTE checking validation of email
      if (email) {
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      } else return true;
    },
    deleteUniInfo(index) {
      this.form.education.splice(index, 1);
    },
    addUniInfo() {
      this.form.education.push({
        start: "",
        end: "",
        university: "",
        major: "",
        grade: "",
      });
      this.openEducation = [];
      this.openEducation.push(this.form.education.length - 1);
    },
    deleteJob(index) {
      this.form.jobs.splice(index, 1);
    },
    addJob() {
      this.form.jobs.push({
        start: "",
        end: "",
        university: "",
        major: "",
        grade: "",
        salary: "",
      });
      this.openJob = [];
      this.openJob.push(this.form.jobs.length - 1);
    },
    sendForm() {
      this.vLoading = true;
      this.isBusy = true;
      if (
        !this.form.email ||
        !this.form.name ||
        !this.form.lastName ||
        !this.form.gender ||
        !this.form.birthCity ||
        !this.form.birthDate ||
        !this.form.age ||
        !this.form.marriage ||
        !this.form.address ||
        !this.form.homeStatus ||
        !this.form.mobile ||
        !this.form.phone ||
        !this.form.latestDegree ||
        !this.form.experience ||
        !this.form.salary ||
        !this.form.field
      ) {
        this.toast("لطفا تمام فیلدهای فرم را با دقت پر کنید", "error");
        this.vLoading = false;
        this.isBusy = false;
      } else {
        Axios.post(this.baseUrl + "/ppkpms/public/form/new", {
          email: this.form.email,
          name: this.form.name,
          lastName: this.form.lastName,
          natCode: this.form.natCode.toString(),
          gender: this.form.gender,
          birthCity: this.form.birthCity,
          birthDate: this.form.birthDate,
          age: this.form.age.toString(),
          marriage: this.form.marriage,
          children: this.form.children.toString(),
          custody: this.form.custody.toString(),
          address: this.form.address,
          homeStatus: this.form.homeStatus,
          mobile: this.form.mobile.toString(),
          phone: this.form.phone.toString(),
          latestDegree: this.form.latestDegree,
          education: JSON.stringify(this.form.education),
          experience: this.form.experience.toString(),
          jobs: JSON.stringify(this.form.jobs),
          salary: this.form.salary.toString(),
          field: this.form.field,
        })
          .then((res) => {
            this.vLoading = false;
            this.isBusy = false;
            if (res.status == 201) {
              this.form = {};
              this.toast("فرم با موفقیت ارسال شد", "success");
              this.$router.push("/recruitmentformSent");
            } else {
              this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
            }
          })
          .catch((err) => {
            this.vLoading = false;
            this.isBusy = false;
            this.toast(err.response.data, "error");
          });
      }
    },
  },
  computed: {
    rules() {
      return {
        isValidNatCode: (value) =>
          (value && this.isID(value)) || "کد ملی وارد شده صحیح نیست!",
        isValidEmail: (value) =>
          (value && this.validateEmail(value)) || "ایمیل وارد شده صحیح نیست!",
      };
    },
  },
};
</script>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.form-page {
  background-color: #fafafa;
  .v-input__slot {
    border-radius: 8px !important;
  }
  .v-btn {
    border-radius: 6px;
  }
  tbody tr:nth-child(even) {
    background-color: #4587991b !important;
  }

  .top-card {
    border-radius: 12px !important;
    box-shadow: none !important;
    border: 1px dashed #bbbbbb !important;
  }
  .main-card {
    border-radius: 12px !important;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.15) 0px 1px 3px 1px !important;
  }
  .calendar-icon {
    path {
      stroke: #0090b8;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
}
</style>
